import { PricingPageHero } from '@/components/pricing/PricingPageHero';
import { ModernPricingSection } from '@/components/pricing/ModernPricingSection';
import { FeatureComparisonTable } from '@/components/pricing/FeatureComparisonTable';
import { AddOnsGrid } from '@/components/pricing/AddOnsGrid';
import { PricingFAQ } from '@/components/pricing/PricingFAQ';
import { PricingCTABanner } from '@/components/pricing/PricingCTABanner';
import { PublicHeader } from '@/components/PublicHeader';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { useEffect } from 'react';

export default function PricingPage() {
  useEffect(() => {
    document.title = 'Pricing | CampChef Pro - Flexible Plans for Camp Kitchens';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Simple, transparent pricing for camps and retreats. From small weekend programs to multi-site operations, CampChef Pro scales with your kitchen. Plans start at $179/month.');
    }
    
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <main>
        <PricingPageHero />
        <ModernPricingSection />
        <FeatureComparisonTable />
        <AddOnsGrid />
        <PricingFAQ />
        <PricingCTABanner />
      </main>
      <LandingFooter />
    </div>
  );
}
